export default {"src":"/_next/static/image/public/images/ic_cod.ae403c049a46ef9a265b5ab7c16ebdb3.svg","height":29,"width":50};